import CouponForm from "../../../forms/Coupons";
import { CreateSingleCoupon } from "../../../services/coupons";
import { useEffect } from "react";
import { GetBundles } from "../../../services/bundle";
import useBundlesStore from "../../../store/bundle/index";
const CreateCoupon = () => {
  const { setBundles, bundles } = useBundlesStore();
  const handleSubmit = async (payload) => {
    const { data } = await CreateSingleCoupon(payload);
    return {
      data,
    };
  };
  const fetchBundles = async () => {
    if (!bundles.length) {
      const { data } = await GetBundles();
      if (data.result) {
        setBundles(data.result);
      }
    }
  };
  useEffect(() => {
    fetchBundles();
  }, []);
  return (
    <>
      <CouponForm
        editable={true}
        heading={"Create coupon"}
        onSubmit={handleSubmit}
      />
    </>
  );
};

export default CreateCoupon;
